/** The note row used by Home and Search — title, tags, dates, optional snippet. */

import type { NoteSummary } from "../api/types";
import { el } from "../lib/dom";
import { formatDate, formatRelative } from "../lib/dates";
import { notePath } from "../router/paths";
import { tagList } from "./tags";

export interface NoteRowOptions {
  readonly note: NoteSummary;
  /** Pre-built highlighted snippet from a search hit. */
  readonly snippet?: DocumentFragment;
}

export function noteRow(options: NoteRowOptions): HTMLElement {
  const { note } = options;

  const updated = el("time", {
    className: "note-row__date",
    text: formatRelative(note.updatedAt),
    attrs: {
      datetime: note.updatedAt,
      title: `Updated ${formatDate(note.updatedAt)}`,
    },
  });

  const snippet =
    options.snippet === undefined ? null : el("p", { className: "note-row__snippet", children: [options.snippet] });

  // Tab walks title to title; the chips stay clickable but are not stops.
  const tags = tagList(note.tags, { skipTab: true });

  return el("article", {
    className: "note-row",
    children: [
      el("h3", {
        className: "note-row__title",
        children: [el("a", { attrs: { href: notePath(note.noteId) }, text: note.title })],
      }),
      updated,
      snippet,
      el("div", {
        className: "note-row__meta",
        children: [el("span", { className: "note-row__folder", text: note.folder }), tags],
      }),
    ],
  });
}

export function noteList(notes: readonly NoteSummary[]): HTMLElement {
  return el("ul", {
    className: "note-list",
    children: notes.map((note) => el("li", { children: [noteRow({ note })] })),
  });
}
